<template>
  <el-table :data="data">
    <el-table-column
      :align="align"
      prop="key1"
      label="序号"
      type="index"
      width="50"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="itemCategoryName"
      label="费项类型"
      width="150"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="itemServiceName"
      label="费项"
      width="100"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="amount"
      label="金额"
      width="100"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="objectStatusTypeName"
      label="结算对象类型"
      width="180"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="objectName"
      label="结算对象"
      width="150"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="paymentMethod"
      label="付款方式"
      width="150"
    ></el-table-column>
    <el-table-column
      :align="align"
      prop="financeNumber"
      label="财务收支单号"
      width="150"
    ></el-table-column>
    <el-table-column :align="align" prop="files" label="图片">
      <template #default="{ row }">
        <el-button type="text" @click="checkAttach(row)">查看</el-button>
      </template>
    </el-table-column>
    <el-table-column
      :align="align"
      prop="remarks"
      label="备注"
    ></el-table-column>
  </el-table>
</template>

<script>
import MyImageView from "@/components/MyImageView.vue";
export default {
  components: {
    MyImageView,
  },
  props: {
    data: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      align: "left",
    };
  },
  methods:{
    checkAttach(row){
      console.log(row)
      this.$showImages('bill_tms_waybill_finance_item_service_v3:document_status',row.number)
    }
  }
};
</script>

<style>
</style>